import type { DialogDesignTokens, DialogTokenSections } from '@openng/optimus-ui-themes/types/dialog';

export const content: DialogTokenSections.Content = {
	padding: '1.5rem 1rem 1.5rem 1rem',
};

export default {
	content,
} satisfies DialogDesignTokens;
